// Minimal imports - only what's needed for bumps
import React from 'react';
import { cfwDomReady } from './_functions';
import PostPurchaseBumps from './frontend/Components/PostPurchaseBumps';
import cfwRenderComponentIfElementExists from './functions/cfwRenderComponentIfElementExists';

class PostPurchase {
    constructor() {
        cfwDomReady(() => {
            // Render PostPurchaseBumps if data exists
            cfwRenderComponentIfElementExists(
                'cfw-post-purchase-root',
                <PostPurchaseBumps />,
                (window as any).cfw_post_purchase_data?.current_bump
            );
        });
    }
}

new PostPurchase();